import { makeStyles } from '@material-ui/core';
import { APP_PRIMARY } from 'colours';

export const useSectionNavigationStyles = makeStyles((theme) => ({
  box: (props) => ({
    backgroundImage: props.backgroundImage
      ? `url(${props.backgroundImage})`
      : 'none',
    height: props.height ? props.height : '72px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'default',
    //marginRight: '4rem',
  }),
  text: (props) => ({
    color: props.secondary ? APP_PRIMARY : '#fff',
    textTransform: 'uppercase',
    paddingLeft: '1rem',
  }),
}));
